import {useEffect, useState} from "react";
import WritebackStatusToolTable from "root/s360components/Tables/WritebackStatusToolTable";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {getAllWondeWebhookRecordsWithDetails} from "root/DataFunctions/MisStatusManagerDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const MisStatusToolManager = ({statusFilter, dateFilter}) =>
{
    const [data, setData] = useState({isLoading: true, data: []});

    const getData = () =>
    {
        getAllWondeWebhookRecordsWithDetails(statusFilter, dateFilter,  (response) =>
        {
            setData({isLoading: false, data: getDataFromResponse(response)});
        })
    }

    useEffect(() =>
    {
        if (statusFilter && dateFilter)
        {
            getData();
        }
    }, [statusFilter, dateFilter])

    return (
        <div>
            {data.isLoading === true && <SpinnerDiv/>}
            {data.isLoading === false && <WritebackStatusToolTable data={data.data}/>}
        </div>
    )
}

export default MisStatusToolManager;